const addZero = (val) => {
  return val.toString().length === 1 ? `${'0' + val.toString()}` : val.toString();
};

export default addZero;
